export const make = (value, previous) => ({
  value,
  previous
});
//# sourceMappingURL=stack.js.map